import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import {getCheckboxChecked, getTextInputValue, setCheckboxChecked, setTextInputValue} from "./foreign.js";
const $BooleanInputType = tag => ({tag});
const Checkbox = /* #__PURE__ */ $BooleanInputType("Checkbox");
const Radio = /* #__PURE__ */ $BooleanInputType("Radio");
const unsafeEventKey = event => {
  const $0 = event.key;
  return () => $0;
};
const textareaOnChange = dictMonadWidget => {
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const bind = MonadCleanup1.Monad0().Bind1().bind;
  const MonadDomBuilder0 = dictMonadWidget.MonadDomBuilder0();
  const elDynAttr$p = MonadDomBuilder0["elDynAttrNS'"](Data$dMaybe.Nothing);
  const $0 = dictMonadWidget.MonadFRP1().MonadEffect0();
  const monadFRP = {MonadEffect0: () => $0, MonadCleanup1: () => MonadCleanup1};
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP);
  const holdDyn = Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
  return initial => attrs => bind(elDynAttr$p("textarea")(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(attrs))(MonadDomBuilder0.text(initial)))(v => {
    const $1 = v._1;
    return bind(domEventWithSample(v1 => getTextInputValue($1))("change")($1))(changed => holdDyn(initial)(changed));
  });
};
const textInputValueOnChange = dictMonadFRP => {
  const bind = dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind;
  const liftEffect = dictMonadFRP.MonadEffect0().liftEffect;
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(dictMonadFRP);
  const holdDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x);
  return v => {
    const $0 = v.element;
    const $1 = v.setValue;
    return bind(liftEffect(getTextInputValue($0)))(initial => bind(domEventWithSample(v1 => getTextInputValue($0))("change")($0))(changed => holdDyn(initial)(Specular$dFRP$dBase.leftmost([
      $1,
      changed
    ]))));
  };
};
const textInputValueEventOnEnter = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const bind = Monad0.Bind1().bind;
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(dictMonadFRP);
  const pure2 = Monad0.Applicative0().pure;
  return v => {
    const $0 = v.value;
    return bind(domEventWithSample(unsafeEventKey)("keypress")(v.element))(keypress => pure2(Specular$dFRP$dBase.sampleAt(Specular$dFRP$dBase.functorEvent.map(v$1 => Specular$dFRP$dBase.identity)(Specular$dFRP$dBase.functorEvent.map(v$1 => {})(Specular$dFRP$dBase.filterEvent(v1 => v1 === "Enter")(keypress))))($0)));
  };
};
const textInputValue = v => v.value;
const textInput = dictMonadWidget => {
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const elDynAttr$p = dictMonadWidget.MonadDomBuilder0()["elDynAttrNS'"](Data$dMaybe.Nothing);
  const pure2 = Monad0.Applicative0().pure;
  const MonadEffect0 = dictMonadWidget.MonadFRP1().MonadEffect0();
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(MonadEffect0)(MonadCleanup1);
  const monadFRP = {MonadEffect0: () => MonadEffect0, MonadCleanup1: () => MonadCleanup1};
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP);
  const holdDyn = Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
  return config => Bind1.bind(elDynAttr$p("input")(config.attributes)(pure2()))(v => {
    const $0 = v._1;
    return Bind1.bind(MonadEffect0.liftEffect(setTextInputValue($0)(config.initialValue)))(() => Bind1.bind(subscribeEvent_(setTextInputValue($0))(config.setValue))(() => Bind1.bind(domEventWithSample(v1 => getTextInputValue($0))("input")($0))(domChanged => Bind1.bind(holdDyn(config.initialValue)(Specular$dFRP$dBase.leftmost([
      domChanged,
      config.setValue
    ])))(value => pure2({element: $0, value, setValue: config.setValue})))));
  });
};
const textInputOnChange = dictMonadWidget => {
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const bind = MonadCleanup1.Monad0().Bind1().bind;
  const textInput1 = textInput(dictMonadWidget);
  const textInputValueOnChange1 = textInputValueOnChange((() => {
    const $0 = dictMonadWidget.MonadFRP1().MonadEffect0();
    return {MonadEffect0: () => $0, MonadCleanup1: () => MonadCleanup1};
  })());
  return initial => attrs => bind(textInput1({initialValue: initial, attributes: Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(attrs), setValue: Specular$dFRP$dBase.never}))(input => textInputValueOnChange1(input));
};
const textInputOnInput = dictMonadWidget => {
  const map1 = dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
  const textInput1 = textInput(dictMonadWidget);
  return initial => attrs => map1(textInputValue)(textInput1({
    initialValue: initial,
    attributes: Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(attrs),
    setValue: Specular$dFRP$dBase.never
  }));
};
const checkbox = dictMonadWidget => {
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const bind = Monad0.Bind1().bind;
  const elDynAttr$p = dictMonadWidget.MonadDomBuilder0()["elDynAttrNS'"](Data$dMaybe.Nothing);
  const pure2 = Monad0.Applicative0().pure;
  const $0 = dictMonadWidget.MonadFRP1().MonadEffect0();
  const monadFRP = {MonadEffect0: () => $0, MonadCleanup1: () => MonadCleanup1};
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP);
  const holdDyn = Specular$dFRP$dBase.foldDyn(monadFRP)(x => v => x);
  return initial => attrs => bind(elDynAttr$p("input")(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(Foreign$dObject.unionWith(Data$dSemigroup.concatString)(attrs)(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $1 = {};
    $1.type = "checkbox";
    return $1;
  })())((() => {
    if (initial) {
      const $1 = {};
      $1.checked = "checked";
      return $1;
    }
    return Foreign$dObject.empty;
  })()))))(pure2()))(v => {
    const $1 = v._1;
    return bind(domEventWithSample(v1 => getCheckboxChecked($1))("change")($1))(changed => holdDyn(initial)(changed));
  });
};
const booleanInputView = dictMonadWidget => {
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const elDynAttr$p = dictMonadWidget.MonadDomBuilder0()["elDynAttrNS'"](Data$dMaybe.Nothing);
  const pure2 = Monad0.Applicative0().pure;
  const $0 = dictMonadWidget.MonadFRP1().MonadEffect0();
  const monadFRP = {MonadEffect0: () => $0, MonadCleanup1: () => MonadCleanup1};
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(monadFRP);
  const domEventWithSample = Specular$dDom$dBuilder$dClass.domEventWithSample(monadFRP);
  return type_ => dchecked => dattrs => Bind1.bind(elDynAttr$p("input")(Specular$dFRP$dBase.functorDynamic.map(v1 => {
    if (v1.tag === "Just") {
      return Data$dMaybe.$Maybe(
        "Just",
        Foreign$dObject.unionWith(Data$dSemigroup.concatString)(v1._1)((() => {
          const $1 = (() => {
            if (type_.tag === "Checkbox") { return "checkbox"; }
            if (type_.tag === "Radio") { return "radio"; }
            $runtime.fail();
          })();
          return (() => {
            const $2 = {};
            $2.type = $1;
            return $2;
          })();
        })())
      );
    }
    return Data$dMaybe.Nothing;
  })(dattrs))(pure2()))(v => {
    const $1 = v._1;
    return Bind1.bind(subscribeDyn_(Specular$dFRP$dWeakDynamic.traverse_(setCheckboxChecked($1)))(dchecked))(() => domEventWithSample(v1 => getCheckboxChecked($1))("change")($1));
  });
};
const checkboxView = dictMonadWidget => booleanInputView(dictMonadWidget)(Checkbox);
export {
  $BooleanInputType,
  Checkbox,
  Radio,
  booleanInputView,
  checkbox,
  checkboxView,
  textInput,
  textInputOnChange,
  textInputOnInput,
  textInputValue,
  textInputValueEventOnEnter,
  textInputValueOnChange,
  textareaOnChange,
  unsafeEventKey
};
export * from "./foreign.js";
